import { FormItem } from 'azure-devops-ui/FormItem';
import { TextField, TextFieldStyle, TextFieldWidth } from 'azure-devops-ui/TextField';
import React from 'react';
import { ObservableValue } from 'azure-devops-ui/Core/Observable';
import { Panel } from 'azure-devops-ui/Panel';
import { DefinitionOfReadyCriteria } from '../../../types';

export interface IDefinitionOfReadyCriteriaEditorProps {
  criteria: DefinitionOfReadyCriteria;
  onCriteriaChanged: (criteria: DefinitionOfReadyCriteria) => void;
  onCancel: () => void;
  onDelete: () => void;
}

export default function DefinitionOfReadyCriteriaEditor(props: IDefinitionOfReadyCriteriaEditorProps) {
  const criteria = new ObservableValue<string>(props.criteria);

  return (
    <Panel
      onDismiss={() => props.onCancel()}
      titleProps={{ text: `Criteria definition` }}
      description={`Define one of the criteria for the Definition of Ready in a sentence. For example: 
          "Achieve a unified understanding of the story and its scope within the feature team through the *3 amigos* approach."`}
      footerButtonProps={[
        { text: 'Cancel', onClick: () => props.onCancel() },
        { text: 'Delete', danger: true, onClick: () => props.onDelete() },
        {
          text: 'Save',
          primary: true,
          onClick: () => props.onCriteriaChanged(criteria.value),
        },
      ]}
    >
      <div className='flex-column rhythm-vertical-16 full-width' style={{ flexWrap: 'wrap' }}>
        <FormItem label='Criteria' message='The criteria definition'>
          <TextField
            value={criteria}
            onChange={(event, value) => {
              criteria.value = value;
            }}
            width={TextFieldWidth.auto}
            multiline
            rows={7}
            required
            style={TextFieldStyle.inline}
          />
        </FormItem>
      </div>
    </Panel>
  );
}
